import { z } from 'zod';

export const UpdateTagSchema = z.object({
  name: z.string().min(1),
});

export type IUpdateTagDto = z.infer<typeof UpdateTagSchema>;
